<div id="int-songrequests-main" class="w-full h-full">
  <app-internal-toolbar [title]="'internal.songrequests.title' | translate">
    @if (songRequestsEnabled() == undefined) {
      <p-skeleton class="ml-8 desktop" title width="5rem" height="1.8125rem" />
    } @else {
      <p-tag
        title
        class="ml-8 desktop"
        [severity]="songRequestsEnabled() ? 'success' : 'danger'"
        [value]="
          (songRequestsEnabled() ? 'internal.songrequests.enabled' : 'internal.songrequests.disabled')
            | translate
        "
      />
    }

    <div actions class="flex flex-row items-center gap-2 mr-2 desktop">
      <p-toggleswitch
        [ngModel]="songRequestsEnabled()"
        (onChange)="toggleAutoReload($event.checked)"
        [disabled]="loadingSongRequests()"
      />
      <mat-icon>refresh</mat-icon>
    </div>

    <reactive-button
      actions
      [label]="'general.refresh' | translate"
      icon="refresh"
      variant="outlined"
      [disabled]="loadingSongRequests()"
      (onClick)="loadSongRequests()"
    ></reactive-button>

    @if (api.hasPermission('delete_songrequests')) {
      <reactive-button
        actions
        [label]="'internal.songrequests.deleteAll' | translate"
        icon="add"
        variant="outlined"
        [disabled]="songRequests().length == 0 || loadingSongRequests()"
        (onClick)="deleteAllSongRequests()"
      ></reactive-button>
    }
  </app-internal-toolbar>

  @if (!songRequestsEnabled() && !loadingSongRequests()) {
    <p-message class="m-5" severity="warn">{{
      'songrequests.disabled' | translate
    }}</p-message>
  }

  <div class="w-full h-fit overflow-auto">
    <div class="flex p-4">
      @if (songRequestsEnabled() == undefined) {
        <p-skeleton class="mobile" width="5rem" height="1.8125rem" />
      } @else {
        <p-tag
          class="mobile"
          [severity]="songRequestsEnabled() ? 'success' : 'danger'"
          [value]="
            (songRequestsEnabled() ? 'internal.songrequests.enabled' : 'internal.songrequests.disabled')
              | translate
          "
        />
      }

      <div class="ml-auto flex flex-row items-center gap-2 mr-2 mobile">
        <p-toggleswitch
          [ngModel]="songRequestsEnabled()"
          (onChange)="toggleAutoReload($event.checked)"
          [disabled]="loadingSongRequests()"
        />
        <mat-icon>refresh</mat-icon>
      </div>
    </div>

    <p-table
      #musicwishTable
      [value]="songRequests()"
      dataKey="_id"
      [paginator]="true"
      [rows]="100"
      [tableStyle]="{ 'min-width': '30rem' }"
      [rowsPerPageOptions]="[5, 10, 20, 50, 100]"
      [globalFilterFields]="['title', 'artist', 'votes', 'played', 'delete']"
    >
      <ng-template #caption>
        <div class="flex">
          <p-iconfield iconPosition="left" class="ml-auto">
            <p-inputicon>
              <mat-icon [size]="20">search</mat-icon>
            </p-inputicon>
            <input
              pInputText
              type="text"
              (input)="musicwishTable.filterGlobal($event.target.value, 'contains')"
              [placeholder]="'general.searchPlaceholder' | translate"
            />
          </p-iconfield>
        </div>
      </ng-template>
      <ng-template #header>
        <tr>
          <th style="width: 48px">{{ 'internal.songrequests.spotifySearch' | translate }}</th>
          <th style="width: auto">{{ 'internal.songrequests.songTitle' | translate }}</th>
          <th style="width: auto">{{ 'internal.songrequests.songArtist' | translate }}</th>
          <th style="width: auto">{{ 'internal.songrequests.votes' | translate }}</th>
          <th style="width: 48px">{{ 'internal.songrequests.played' | translate }}</th>
          <th style="width: 48px">{{ 'internal.songrequests.delete' | translate }}</th>
        </tr>
        <tr class="desktop">
          <th></th>
          <th>
            <p-columnFilter
              type="text"
              field="title"
              [placeholder]="'general.searchPlaceholder' | translate"
              filterOn="input"
              matchMode="contains"
            ></p-columnFilter>
          </th>
          <th>
            <p-columnFilter
              type="text"
              field="artist"
              [placeholder]="'general.searchPlaceholder' | translate"
              filterOn="input"
              matchMode="contains"
            ></p-columnFilter>
          </th>
          <th></th>
          <th></th>
          <th></th>
        </tr>
      </ng-template>
      <ng-template #body let-wish>
        <tr>
          @if (loadingSongRequests()) {
            <td><p-skeleton /></td>
            <td><p-skeleton /></td>
            <td><p-skeleton /></td>
            <td><p-skeleton /></td>
            <td><p-skeleton /></td>
            <td><p-skeleton /></td>
          } @else {
            <td>
              <a
                pButton
                iconOnly
                [rounded]="true"
                [outlined]="true"
                [text]="true"
                variant="text"
                severity="secondary"
                [href]="getSpotifySearchUrl(wish.artist, wish.title)"
                target="_blank"
              >
                <mat-icon>library_music</mat-icon>
              </a>
            </td>
            <td (click)="copySongRequest(wish)">{{ wish.title }}</td>
            <td (click)="copySongRequest(wish)">{{ wish.artist }}</td>
            <td (click)="copySongRequest(wish)">{{ wish.votes }}</td>
            <td>
              <p-button
                [severity]="
                  savingRequestList().includes(wish._id)
                    ? 'secondary'
                    : wish.played
                      ? 'success'
                      : 'warn'
                "
                [rounded]="true"
                [outlined]="true"
                variant="text"
                (onClick)="toggleSongRequestPlayed(wish)"
                [disabled]="!api.hasPermission('edit_songrequests')"
              >
                @if (savingRequestList().includes(wish._id)) {
                  <mat-icon iconClass="animate-spin">progress_activity</mat-icon>
                } @else {
                  <mat-icon>{{ wish.played ? 'play_arrow' : 'play_disabled' }}</mat-icon>
                }
              </p-button>
            </td>
            <td>
              <p-button
                iconOnly
                [rounded]="true"
                [outlined]="true"
                variant="text"
                severity="danger"
                (onClick)="deleteSongRequest(wish)"
                [disabled]="!api.hasPermission('delete_songrequests')"
              >
                <mat-icon>delete</mat-icon>
              </p-button>
            </td>
          }
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
